import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-gray-900" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center space-x-3" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "p-6 space-y-6" }
const _hoisted_6 = { class: "flex flex-wrap items-center gap-4" }
const _hoisted_7 = { class: "flex items-center space-x-2" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
}
const _hoisted_12 = { class: "flex items-center space-x-2" }
const _hoisted_13 = {
  key: 1,
  class: "flex items-center space-x-2"
}
const _hoisted_14 = {
  key: 3,
  class: "flex items-center space-x-2"
}
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
}
const _hoisted_19 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 relative"
}
const _hoisted_20 = {
  key: 0,
  class: "absolute inset-0 bg-gray-900 bg-opacity-30 flex items-center justify-center z-10 rounded-xl"
}
const _hoisted_21 = { class: "flex items-start justify-between" }
const _hoisted_22 = { class: "flex-1" }
const _hoisted_23 = { class: "flex items-start justify-between" }
const _hoisted_24 = { class: "flex-1" }
const _hoisted_25 = { class: "flex items-start justify-between" }
const _hoisted_26 = { class: "flex-1" }
const _hoisted_27 = { class: "flex items-baseline space-x-2" }
const _hoisted_28 = { class: "mt-2.5 w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1 overflow-hidden" }
const _hoisted_29 = { class: "flex items-start justify-between" }
const _hoisted_30 = { class: "flex-1" }
const _hoisted_31 = { class: "flex" }
const _hoisted_32 = { class: "ml-3" }
const _hoisted_33 = { class: "mt-2 text-sm text-red-700 dark:text-red-300" }
const _hoisted_34 = { class: "flex flex-col items-center justify-center" }
const _hoisted_35 = {
  key: 3,
  class: "relative"
}
const _hoisted_36 = {
  key: 0,
  class: "absolute inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-20 rounded-xl backdrop-blur-sm"
}
const _hoisted_37 = { class: "flex items-center justify-between" }
const _hoisted_38 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_39 = { class: "flex items-center space-x-1" }
const _hoisted_40 = {
  key: 0,
  class: "w-4 h-4",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_41 = {
  key: 0,
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_42 = {
  key: 1,
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_43 = { class: "flex items-center space-x-1" }
const _hoisted_44 = {
  key: 0,
  class: "w-4 h-4",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_45 = {
  key: 0,
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_46 = {
  key: 1,
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_47 = { class: "flex items-center justify-center space-x-1" }
const _hoisted_48 = {
  key: 0,
  class: "w-4 h-4",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_49 = {
  key: 0,
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_50 = {
  key: 1,
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_51 = { class: "flex items-center justify-center space-x-1" }
const _hoisted_52 = {
  key: 0,
  class: "w-4 h-4",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_53 = {
  key: 0,
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_54 = {
  key: 1,
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_55 = { class: "flex items-center justify-center space-x-1" }
const _hoisted_56 = {
  key: 0,
  class: "w-4 h-4",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_57 = {
  key: 0,
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_58 = {
  key: 1,
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_59 = { class: "flex items-center justify-center space-x-1" }
const _hoisted_60 = {
  key: 0,
  class: "w-4 h-4",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_61 = {
  key: 0,
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_62 = {
  key: 1,
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_63 = { class: "divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_66 = { class: "flex items-center" }
const _hoisted_67 = {
  key: 0,
  class: "text-2xl",
  title: "1st Place"
}
const _hoisted_68 = {
  key: 1,
  class: "text-2xl",
  title: "2nd Place"
}
const _hoisted_69 = {
  key: 2,
  class: "text-2xl",
  title: "3rd Place"
}
const _hoisted_70 = { class: "px-5 py-4 whitespace-nowrap" }
const _hoisted_71 = { class: "flex items-center space-x-2.5" }
const _hoisted_72 = { class: "flex flex-col" }
const _hoisted_73 = { class: "px-5 py-4 whitespace-nowrap" }
const _hoisted_74 = { class: "w-48" }
const _hoisted_75 = { class: "flex items-center space-x-1.5 mb-1" }
const _hoisted_76 = { class: "w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5 overflow-hidden" }
const _hoisted_77 = { class: "px-4 py-4 whitespace-nowrap text-center" }
const _hoisted_78 = { class: "flex items-center justify-center" }
const _hoisted_79 = { class: "px-4 py-4 whitespace-nowrap text-center" }
const _hoisted_80 = { class: "flex items-center justify-center" }
const _hoisted_81 = { class: "px-4 py-4 whitespace-nowrap text-center" }
const _hoisted_82 = { class: "flex items-center justify-center" }
const _hoisted_83 = { class: "px-4 py-4 whitespace-nowrap text-center" }
const _hoisted_84 = { class: "px-4 py-4 whitespace-nowrap text-center" }
const _hoisted_85 = { class: "flex flex-col items-center" }
const _hoisted_86 = { class: "px-6 py-4 whitespace-nowrap text-right" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { class: "flex flex-col items-center" }
const _hoisted_89 = {
  key: 5,
  class: "text-center"
}
const _hoisted_90 = { class: "flex items-center justify-center space-x-1.5" }
const _hoisted_91 = { class: "font-medium" }

import { ref, reactive, computed, onMounted, inject, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useTheme } from '../../utils/useTheme'
import { leaderboardService } from '../../services/quality-gates'
import type { LeaderboardResponse, TeamStats, TimeRange, GroupBy } from '../../types/quality-gates'
import { logger } from '../../utils/logger'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const theme = inject('theme', useTheme())

// State
const leaderboardData = ref<LeaderboardResponse | null>(null)
const teams = ref<string[]>([])
const qualityGates = ref<string[]>([])
const loading = ref(false)
const loadingTeams = ref(true)
const loadingGates = ref(true)
const error = ref<string | null>(null)

// Initialize filters from URL query params or defaults
const filters = reactive({
  timeRange: (route.query.timeRange as TimeRange) || '7d',
  groupBy: (route.query.groupBy as GroupBy) || 'team',
  team: (route.query.team as string) || '',
  qualityGate: (route.query.qualityGate as string) || ''
})

// Sort state
const sortState = reactive({
  column: 'passRate' as 'passRate' | 'pass' | 'fail' | 'warning' | 'total' | 'name',
  order: 'desc' as 'asc' | 'desc'
})

// Computed
const filteredStats = computed(() => {
  if (!leaderboardData.value) return []
  // Filter out teams/sub-teams with 0 total PRs
  const filtered = leaderboardData.value.stats.filter((stat) => stat.total > 0)

  // Sort based on current sort state
  return [...filtered].sort((a, b) => {
    let comparison = 0

    switch (sortState.column) {
      case 'name':
        const nameA = filters.groupBy === 'subTeam' ? a.subTeam || '' : a.team
        const nameB = filters.groupBy === 'subTeam' ? b.subTeam || '' : b.team
        comparison = nameA.localeCompare(nameB)
        break
      case 'passRate':
        comparison = a.passRate - b.passRate
        break
      case 'pass':
        comparison = a.pass - b.pass
        break
      case 'fail':
        comparison = a.fail - b.fail
        break
      case 'warning':
        comparison = a.warning - b.warning
        break
      case 'total':
        comparison = a.total - b.total
        break
    }

    return sortState.order === 'asc' ? comparison : -comparison
  })
})

const totalFailing = computed(() => {
  if (!leaderboardData.value) return 0
  return leaderboardData.value.stats.reduce((sum, stat) => sum + stat.fail, 0)
})

// Update URL with current filters
const updateURL = () => {
  const query: Record<string, string> = {
    timeRange: filters.timeRange,
    groupBy: filters.groupBy
  }

  if (filters.team) {
    query.team = filters.team
  }

  if (filters.qualityGate) {
    query.qualityGate = filters.qualityGate
  }

  // Use replace to avoid adding to browser history on every filter change
  router.replace({ query })
}

// Methods
const fetchLeaderboard = async () => {
  try {
    loading.value = true
    error.value = null

    // Update URL with current filters
    updateURL()

    logger.log('Fetching leaderboard with filters:', filters)

    const data = await leaderboardService.fetchLeaderboard({
      timeRange: filters.timeRange,
      groupBy: filters.groupBy,
      team: filters.team || undefined,
      qualityGate: filters.qualityGate || undefined
    })

    leaderboardData.value = data

    logger.log('Leaderboard loaded:', {
      teamsCount: data.stats.length,
      totalPRs: data.totalPRs
    })
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Failed to load leaderboard'
    logger.error('Error fetching leaderboard:', err)
  } finally {
    loading.value = false
  }
}

const fetchTeams = async () => {
  try {
    loadingTeams.value = true
    const teamsData = await leaderboardService.fetchTeams()
    teams.value = teamsData.teams
  } catch (err) {
    logger.error('Error fetching teams:', err)
  } finally {
    loadingTeams.value = false
  }
}

const fetchQualityGates = async () => {
  try {
    loadingGates.value = true
    const gatesData = await leaderboardService.fetchQualityGates()
    qualityGates.value = gatesData.gates
  } catch (err) {
    logger.error('Error fetching quality gates:', err)
  } finally {
    loadingGates.value = false
  }
}

const navigateToPRList = (stat: TeamStats) => {
  // Navigate to leaderboard details page with team/subTeam filter
  const query: Record<string, string> = {
    team: stat.team,
    timeRange: filters.timeRange
  }

  if (filters.groupBy === 'subTeam' && stat.subTeam) {
    query.subTeam = stat.subTeam
  }

  if (filters.qualityGate) {
    query.qualityGate = filters.qualityGate
  }

  router.push({
    path: '/quality-gates/compliance/details',
    query
  })
}

const formatGeneratedAt = (isoString: string): string => {
  try {
    const date = new Date(isoString)
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short'
    })
  } catch {
    return isoString
  }
}

const sortBy = (column: typeof sortState.column) => {
  if (sortState.column === column) {
    // Toggle order if clicking the same column
    sortState.order = sortState.order === 'asc' ? 'desc' : 'asc'
  } else {
    // Set new column and default to descending for numbers, ascending for names
    sortState.column = column
    sortState.order = column === 'name' ? 'asc' : 'desc'
  }
}

// Watch for URL query changes (e.g., browser back/forward)
// Skip initial call since onMounted handles it
watch(
  () => route.query,
  (newQuery, oldQuery) => {
    // Only update if query actually changed (handles browser back/forward)
    const queryChanged =
      newQuery.timeRange !== oldQuery?.timeRange ||
      newQuery.groupBy !== oldQuery?.groupBy ||
      newQuery.team !== oldQuery?.team ||
      newQuery.qualityGate !== oldQuery?.qualityGate

    if (queryChanged) {
      // Update filters from URL
      filters.timeRange = (newQuery.timeRange as TimeRange) || '7d'
      filters.groupBy = (newQuery.groupBy as GroupBy) || 'team'
      filters.team = (newQuery.team as string) || ''
      filters.qualityGate = (newQuery.qualityGate as string) || ''

      // Only fetch if not already loading (prevents double-fetch)
      if (!loading.value) {
        fetchLeaderboard()
      }
    }
  }
)

// Lifecycle
onMounted(() => {
  fetchLeaderboard()
  fetchTeams()
  fetchQualityGates()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
        'border-b px-6 py-3'
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex items-center justify-center w-9 h-9 rounded-lg bg-gradient-to-br from-yellow-400 to-orange-500" }, [
            _createElementVNode("svg", {
              class: "w-5 h-5 text-white",
              fill: "currentColor",
              viewBox: "0 0 20 20"
            }, [
              _createElementVNode("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" })
            ])
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("h1", {
              class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-100' : 'text-gray-900', 'text-xl font-bold'])
            }, " Quality Gates Compliance ", 2),
            _createElementVNode("p", {
              class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600', 'text-xs'])
            }, " Mandatory compliance tracking: all teams are expected to reach 100% completion ", 2)
          ])
        ]),
        _createElementVNode("button", {
          disabled: loading.value,
          class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-gray-700 hover:bg-gray-600 text-gray-200'
              : 'bg-white hover:bg-gray-50 text-gray-700',
            'px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg text-xs font-medium transition-all flex items-center shadow-sm hover:shadow',
            loading.value ? 'opacity-50 cursor-not-allowed' : ''
          ]),
          onClick: fetchLeaderboard
        }, [
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass([loading.value ? 'animate-spin' : '', 'w-3.5 h-3.5 mr-1.5']),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, _cache[11] || (_cache[11] = [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            }, null, -1)
          ]), 2)),
          _createTextVNode(" " + _toDisplayString(loading.value ? 'Loading...' : 'Refresh'), 1)
        ], 10, _hoisted_4)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg p-3 shadow-sm'
        ])
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", {
              class: _normalizeClass([
                _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                'text-xs font-medium whitespace-nowrap'
              ])
            }, " Team: ", 2),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.team) = $event)),
                disabled: loadingTeams.value,
                class: _normalizeClass([
                  _unref(theme).isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-650'
                    : 'bg-white border-gray-300 text-gray-900 hover:bg-gray-50',
                  'px-3 py-1.5 border rounded-md text-xs font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all cursor-pointer pr-8',
                  loadingTeams.value ? 'opacity-75 cursor-wait' : ''
                ]),
                onChange: fetchLeaderboard
              }, [
                _cache[12] || (_cache[12] = _createElementVNode("option", { value: "" }, "All Teams", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teams.value, (team) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: team,
                    value: team
                  }, _toDisplayString(_unref(leaderboardService).formatTeamName(team)), 9, _hoisted_10))
                }), 128))
              ], 42, _hoisted_9), [
                [_vModelSelect, filters.team]
              ]),
              (loadingTeams.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[13] || (_cache[13] = [
                    _createElementVNode("svg", {
                      class: "animate-spin h-3 w-3 text-blue-500",
                      fill: "none",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                      })
                    ], -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([_unref(theme).isDark.value ? 'bg-gray-700' : 'bg-gray-300', 'w-px h-6'])
          }, null, 2),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", {
              class: _normalizeClass([
                _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                'text-xs font-medium whitespace-nowrap'
              ])
            }, " Time Range: ", 2),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.timeRange) = $event)),
              class: _normalizeClass([
                _unref(theme).isDark.value
                  ? 'bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-650'
                  : 'bg-white border-gray-300 text-gray-900 hover:bg-gray-50',
                'px-3 py-1.5 border rounded-md text-xs font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all cursor-pointer'
              ]),
              onChange: fetchLeaderboard
            }, _cache[14] || (_cache[14] = [
              _createElementVNode("option", { value: "7d" }, "Last 7 Days", -1),
              _createElementVNode("option", { value: "14d" }, "Last 14 Days", -1),
              _createElementVNode("option", { value: "30d" }, "Last 30 Days", -1)
            ]), 34), [
              [_vModelSelect, filters.timeRange]
            ])
          ]),
          (!loadingTeams.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([_unref(theme).isDark.value ? 'bg-gray-700' : 'bg-gray-300', 'w-px h-6'])
              }, null, 2))
            : _createCommentVNode("", true),
          (!loadingTeams.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("label", {
                  class: _normalizeClass([
                _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                'text-xs font-medium whitespace-nowrap'
              ])
                }, " Group By: ", 2),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.groupBy) = $event)),
                  class: _normalizeClass([
                _unref(theme).isDark.value
                  ? 'bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-650'
                  : 'bg-white border-gray-300 text-gray-900 hover:bg-gray-50',
                'px-3 py-1.5 border rounded-md text-xs font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all cursor-pointer'
              ]),
                  onChange: fetchLeaderboard
                }, _cache[15] || (_cache[15] = [
                  _createElementVNode("option", { value: "team" }, "Team", -1),
                  _createElementVNode("option", { value: "subTeam" }, "Sub-Team", -1)
                ]), 34), [
                  [_vModelSelect, filters.groupBy]
                ])
              ]))
            : _createCommentVNode("", true),
          (!loadingTeams.value && !loadingGates.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass([_unref(theme).isDark.value ? 'bg-gray-700' : 'bg-gray-300', 'w-px h-6'])
              }, null, 2))
            : _createCommentVNode("", true),
          (!loadingGates.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("label", {
                  class: _normalizeClass([
                _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                'text-xs font-medium whitespace-nowrap'
              ])
                }, " Quality Gate: ", 2),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.qualityGate) = $event)),
                    disabled: loadingGates.value,
                    class: _normalizeClass([
                  _unref(theme).isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-650'
                    : 'bg-white border-gray-300 text-gray-900 hover:bg-gray-50',
                  'px-3 py-1.5 border rounded-md text-xs font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all cursor-pointer pr-8',
                  loadingGates.value ? 'opacity-75 cursor-wait' : ''
                ]),
                    onChange: fetchLeaderboard
                  }, [
                    _cache[16] || (_cache[16] = _createElementVNode("option", { value: "" }, "All Gates", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qualityGates.value, (gate) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: gate,
                        value: gate
                      }, _toDisplayString(_unref(leaderboardService).formatGateName(gate)), 9, _hoisted_17))
                    }), 128))
                  ], 42, _hoisted_16), [
                    [_vModelSelect, filters.qualityGate]
                  ]),
                  (loadingGates.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[17] || (_cache[17] = [
                        _createElementVNode("svg", {
                          class: "animate-spin h-3 w-3 text-blue-500",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                          })
                        ], -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      (leaderboardData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[18] || (_cache[18] = [
                  _createElementVNode("svg", {
                    class: "animate-spin h-6 w-6 text-blue-500",
                    fill: "none",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("circle", {
                      class: "opacity-25",
                      cx: "12",
                      cy: "12",
                      r: "10",
                      stroke: "currentColor",
                      "stroke-width": "4"
                    }),
                    _createElementVNode("path", {
                      class: "opacity-75",
                      fill: "currentColor",
                      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                    })
                  ], -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-gray-800 border border-gray-700'
              : 'bg-white border border-gray-200',
            'rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow'
          ])
            }, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("p", {
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                  'text-xs font-medium mb-2'
                ])
                  }, _toDisplayString(filters.groupBy === 'subTeam' ? 'Sub-Teams' : 'Teams'), 3),
                  _createElementVNode("p", {
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-blue-400' : 'text-blue-600',
                  'text-3xl font-bold'
                ])
                  }, _toDisplayString(filteredStats.value.length), 3)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([
                _unref(theme).isDark.value ? 'bg-blue-900 bg-opacity-30' : 'bg-blue-50',
                'flex items-center justify-center w-10 h-10 rounded-lg'
              ])
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass([_unref(theme).isDark.value ? 'text-blue-400' : 'text-blue-600', 'w-5 h-5']),
                    fill: "currentColor",
                    viewBox: "0 0 20 20"
                  }, _cache[19] || (_cache[19] = [
                    _createElementVNode("path", { d: "M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" }, null, -1)
                  ]), 2))
                ], 2)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-gray-800 border border-gray-700'
              : 'bg-white border border-gray-200',
            'rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow'
          ])
            }, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("p", {
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                  'text-xs font-medium mb-2'
                ])
                  }, " Total PRs ", 2),
                  _createElementVNode("p", {
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-purple-400' : 'text-purple-600',
                  'text-3xl font-bold'
                ])
                  }, _toDisplayString(leaderboardData.value.totalPRs), 3)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([
                _unref(theme).isDark.value ? 'bg-purple-900 bg-opacity-30' : 'bg-purple-50',
                'flex items-center justify-center w-10 h-10 rounded-lg'
              ])
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass([_unref(theme).isDark.value ? 'text-purple-400' : 'text-purple-600', 'w-5 h-5']),
                    fill: "currentColor",
                    viewBox: "0 0 20 20"
                  }, _cache[20] || (_cache[20] = [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z",
                      "clip-rule": "evenodd"
                    }, null, -1)
                  ]), 2))
                ], 2)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-gray-800 border border-gray-700'
              : 'bg-white border border-gray-200',
            'rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow'
          ])
            }, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("p", {
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                  'text-xs font-medium mb-2'
                ])
                  }, " Overall Compliance Rate ", 2),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("p", {
                      class: _normalizeClass([
                    leaderboardData.value.overallPassRate >= 100
                      ? _unref(theme).isDark.value
                        ? 'text-green-400'
                        : 'text-green-600'
                      : leaderboardData.value.overallPassRate >= 80
                        ? _unref(theme).isDark.value
                          ? 'text-yellow-400'
                          : 'text-yellow-600'
                        : _unref(theme).isDark.value
                          ? 'text-red-400'
                          : 'text-red-600',
                    'text-3xl font-bold'
                  ])
                    }, _toDisplayString(leaderboardData.value.overallPassRate) + "% ", 3),
                    _createElementVNode("span", {
                      class: _normalizeClass([
                    _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                    'text-sm font-medium'
                  ])
                    }, _toDisplayString(leaderboardData.value.overallPassRate >= 100
                      ? 'Compliant'
                      : leaderboardData.value.overallPassRate >= 80
                        ? 'At Risk'
                        : 'Non-Compliant'), 3)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", {
                      class: _normalizeClass([[
                    leaderboardData.value.overallPassRate >= 100
                      ? 'bg-green-500'
                      : leaderboardData.value.overallPassRate >= 80
                        ? 'bg-yellow-500'
                        : 'bg-red-500'
                  ], "h-full transition-all duration-500"]),
                      style: _normalizeStyle({ width: `${leaderboardData.value.overallPassRate}%` })
                    }, null, 6)
                  ])
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-gray-800 border border-gray-700'
              : 'bg-white border border-gray-200',
            'rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow'
          ])
            }, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("p", {
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                  'text-xs font-medium mb-2'
                ])
                  }, " Failing PRs ", 2),
                  _createElementVNode("p", {
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-red-400' : 'text-red-600',
                  'text-3xl font-bold'
                ])
                  }, _toDisplayString(totalFailing.value), 3)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([
                _unref(theme).isDark.value ? 'bg-red-900 bg-opacity-30' : 'bg-red-50',
                'flex items-center justify-center w-10 h-10 rounded-lg'
              ])
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass([_unref(theme).isDark.value ? 'text-red-400' : 'text-red-600', 'w-5 h-5']),
                    fill: "currentColor",
                    viewBox: "0 0 20 20"
                  }, _cache[21] || (_cache[21] = [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                      "clip-rule": "evenodd"
                    }, null, -1)
                  ]), 2))
                ], 2)
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-red-900 border-red-700' : 'bg-red-50 border-red-200',
          'border rounded-md p-4'
        ])
          }, [
            _createElementVNode("div", _hoisted_31, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                _createElementVNode("svg", {
                  class: "h-5 w-5 text-red-400",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_32, [
                _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "text-sm font-medium text-red-800 dark:text-red-200" }, " Error loading compliance data ", -1)),
                _createElementVNode("div", _hoisted_33, _toDisplayString(error.value), 1),
                _createElementVNode("button", {
                  class: "mt-2 px-3 py-1 bg-red-100 dark:bg-red-800 text-red-800 dark:text-red-100 rounded text-sm",
                  onClick: fetchLeaderboard
                }, " Try Again ")
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      (loading.value && !leaderboardData.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-xl p-12'
        ])
          }, [
            _createElementVNode("div", _hoisted_34, [
              _cache[24] || (_cache[24] = _createElementVNode("svg", {
                class: "animate-spin h-10 w-10 text-blue-500",
                fill: "none",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("circle", {
                  class: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  "stroke-width": "4"
                }),
                _createElementVNode("path", {
                  class: "opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                })
              ], -1)),
              _createElementVNode("span", {
                class: _normalizeClass([
              _unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-600',
              'mt-4 text-base font-medium'
            ])
              }, " Loading compliance data... ", 2)
            ])
          ], 2))
        : (leaderboardData.value && filteredStats.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, _cache[25] || (_cache[25] = [
                    _createStaticVNode("<div class=\"bg-white dark:bg-gray-800 rounded-xl p-5 shadow-xl flex items-center space-x-3\"><svg class=\"animate-spin h-5 w-5 text-blue-500\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z\"></path></svg><span class=\"text-gray-900 dark:text-white font-medium\">Updating compliance data...</span></div>", 1)
                  ])))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass([
            _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
            'border rounded-xl overflow-hidden shadow-sm'
          ])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([
              _unref(theme).isDark.value ? 'bg-gray-900' : 'bg-gray-50',
              'px-5 py-2.5 border-b',
              _unref(theme).isDark.value ? 'border-gray-700' : 'border-gray-200'
            ])
                }, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("h2", {
                      class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-gray-200' : 'text-gray-900',
                  'text-base font-semibold'
                ])
                    }, " Compliance Overview ", 2),
                    _createElementVNode("p", {
                      class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-500' : 'text-gray-500', 'text-xs'])
                    }, _toDisplayString(filters.timeRange === '7d'
                    ? 'Last 7 days'
                    : filters.timeRange === '14d'
                      ? 'Last 14 days'
                      : 'Last 30 days'), 3)
                  ])
                ], 2),
                _createElementVNode("table", _hoisted_38, [
                  _createElementVNode("thead", {
                    class: _normalizeClass(_unref(theme).isDark.value ? 'bg-gray-850' : 'bg-gray-100')
                  }, [
                    _createElementVNode("tr", null, [
                      _cache[31] || (_cache[31] = _createElementVNode("th", {
                        scope: "col",
                        class: "px-6 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider"
                      }, " Rank ", -1)),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "px-5 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors select-none",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (sortBy('name')))
                      }, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("span", null, _toDisplayString(filters.groupBy === 'subTeam' ? 'Sub-Team' : 'Team'), 1),
                          (sortState.column === 'name')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_40, [
                                (sortState.order === 'asc')
                                  ? (_openBlock(), _createElementBlock("path", _hoisted_41))
                                  : (_openBlock(), _createElementBlock("path", _hoisted_42))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "px-5 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors select-none",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (sortBy('passRate')))
                      }, [
                        _createElementVNode("div", _hoisted_43, [
                          _cache[26] || (_cache[26] = _createElementVNode("span", null, "Compliance", -1)),
                          (sortState.column === 'passRate')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_44, [
                                (sortState.order === 'asc')
                                  ? (_openBlock(), _createElementBlock("path", _hoisted_45))
                                  : (_openBlock(), _createElementBlock("path", _hoisted_46))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "px-4 py-3 text-center text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors select-none",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (sortBy('pass')))
                      }, [
                        _createElementVNode("div", _hoisted_47, [
                          _cache[27] || (_cache[27] = _createElementVNode("span", null, "Pass", -1)),
                          (sortState.column === 'pass')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_48, [
                                (sortState.order === 'asc')
                                  ? (_openBlock(), _createElementBlock("path", _hoisted_49))
                                  : (_openBlock(), _createElementBlock("path", _hoisted_50))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "px-4 py-3 text-center text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors select-none",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (sortBy('fail')))
                      }, [
                        _createElementVNode("div", _hoisted_51, [
                          _cache[28] || (_cache[28] = _createElementVNode("span", null, "Fail", -1)),
                          (sortState.column === 'fail')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_52, [
                                (sortState.order === 'asc')
                                  ? (_openBlock(), _createElementBlock("path", _hoisted_53))
                                  : (_openBlock(), _createElementBlock("path", _hoisted_54))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "px-4 py-3 text-center text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors select-none",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (sortBy('warning')))
                      }, [
                        _createElementVNode("div", _hoisted_55, [
                          _cache[29] || (_cache[29] = _createElementVNode("span", null, "Warning", -1)),
                          (sortState.column === 'warning')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_56, [
                                (sortState.order === 'asc')
                                  ? (_openBlock(), _createElementBlock("path", _hoisted_57))
                                  : (_openBlock(), _createElementBlock("path", _hoisted_58))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "px-4 py-3 text-center text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors select-none",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (sortBy('total')))
                      }, [
                        _createElementVNode("div", _hoisted_59, [
                          _cache[30] || (_cache[30] = _createElementVNode("span", null, "Total", -1)),
                          (sortState.column === 'total')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_60, [
                                (sortState.order === 'asc')
                                  ? (_openBlock(), _createElementBlock("path", _hoisted_61))
                                  : (_openBlock(), _createElementBlock("path", _hoisted_62))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _cache[32] || (_cache[32] = _createElementVNode("th", {
                        scope: "col",
                        class: "px-4 py-3 text-center text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider"
                      }, " Pass Rate ", -1)),
                      _cache[33] || (_cache[33] = _createElementVNode("th", {
                        scope: "col",
                        class: "px-6 py-3 text-right text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider"
                      }, " Actions ", -1))
                    ])
                  ], 2),
                  _createElementVNode("tbody", _hoisted_63, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredStats.value, (stat, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: stat.team + '-' + (stat.subTeam || ''),
                        class: _normalizeClass([
                  _unref(theme).isDark.value ? 'hover:bg-gray-750' : 'hover:bg-blue-50',
                  'cursor-pointer transition-all duration-150 group'
                ]),
                        onClick: ($event: any) => (navigateToPRList(stat))
                      }, [
                        _createElementVNode("td", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            (index === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_67, " 🥇 "))
                              : (index === 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_68, " 🥈 "))
                                : (index === 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_69, " 🥉 "))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 3,
                                      class: _normalizeClass([
                        _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-500',
                        'text-sm font-semibold'
                      ])
                                    }, " #" + _toDisplayString(index + 1), 3))
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_70, [
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", {
                              class: _normalizeClass([
                        _unref(theme).isDark.value ? 'bg-blue-900 bg-opacity-30' : 'bg-blue-50',
                        'flex-shrink-0 h-9 w-9 rounded-lg flex items-center justify-center'
                      ])
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass([
                          _unref(theme).isDark.value ? 'text-blue-400' : 'text-blue-600',
                          'font-bold text-xs'
                        ])
                              }, _toDisplayString((filters.groupBy === 'subTeam'
                            ? _unref(leaderboardService).formatSubTeamName(stat.subTeam)
                            : _unref(leaderboardService).formatTeamName(stat.team)
                          )
                            .substring(0, 2)
                            .toUpperCase()), 3)
                            ], 2),
                            _createElementVNode("div", _hoisted_72, [
                              _createElementVNode("span", {
                                class: _normalizeClass([
                          _unref(theme).isDark.value ? 'text-white' : 'text-gray-900',
                          'font-semibold text-sm'
                        ])
                              }, _toDisplayString(filters.groupBy === 'subTeam'
                            ? _unref(leaderboardService).formatSubTeamName(stat.subTeam)
                            : _unref(leaderboardService).formatTeamName(stat.team)), 3),
                              (filters.groupBy === 'subTeam' && stat.team)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-500', 'text-xs'])
                                  }, _toDisplayString(_unref(leaderboardService).formatTeamName(stat.team)), 3))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_73, [
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("span", {
                                class: _normalizeClass([
                          stat.passRate >= 100
                            ? _unref(theme).isDark.value
                              ? 'text-green-400'
                              : 'text-green-600'
                            : stat.passRate >= 80
                              ? _unref(theme).isDark.value
                                ? 'text-yellow-400'
                                : 'text-yellow-600'
                              : _unref(theme).isDark.value
                                ? 'text-red-400'
                                : 'text-red-600',
                          'text-base font-bold'
                        ])
                              }, _toDisplayString(stat.passRate) + "% ", 3),
                              _createElementVNode("span", {
                                class: _normalizeClass([
                          _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                          'text-xs font-medium'
                        ])
                              }, _toDisplayString(stat.passRate >= 100
                            ? 'Compliant'
                            : stat.passRate >= 80
                              ? 'At Risk'
                              : 'Non-Compliant'), 3)
                            ]),
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("div", {
                                class: _normalizeClass([[
                          stat.passRate >= 100
                            ? 'bg-green-500'
                            : stat.passRate >= 80
                              ? 'bg-yellow-500'
                              : 'bg-red-500'
                        ], "h-full transition-all duration-500"]),
                                style: _normalizeStyle({ width: `${stat.passRate}%` })
                              }, null, 6)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_77, [
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("span", {
                              class: _normalizeClass([
                        _unref(theme).isDark.value
                          ? 'bg-green-900 bg-opacity-30 text-green-400'
                          : 'bg-green-50 text-green-700',
                        'inline-flex items-center px-2.5 py-1 rounded-lg font-semibold text-xs'
                      ])
                            }, _toDisplayString(stat.pass), 3)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("span", {
                              class: _normalizeClass([
                        _unref(theme).isDark.value
                          ? 'bg-red-900 bg-opacity-30 text-red-400'
                          : 'bg-red-50 text-red-700',
                        'inline-flex items-center px-2.5 py-1 rounded-lg font-semibold text-xs'
                      ])
                            }, _toDisplayString(stat.fail), 3)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("span", {
                              class: _normalizeClass([
                        _unref(theme).isDark.value
                          ? 'bg-yellow-900 bg-opacity-30 text-yellow-400'
                          : 'bg-yellow-50 text-yellow-700',
                        'inline-flex items-center px-2.5 py-1 rounded-lg font-semibold text-xs'
                      ])
                            }, _toDisplayString(stat.warning), 3)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_83, [
                          _createElementVNode("span", {
                            class: _normalizeClass([
                      _unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-700',
                      'font-semibold text-sm'
                    ])
                          }, _toDisplayString(stat.total), 3)
                        ]),
                        _createElementVNode("td", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("span", {
                              class: _normalizeClass([
                        stat.passRate >= 100
                          ? _unref(theme).isDark.value
                            ? 'bg-green-900 bg-opacity-30 text-green-400'
                            : 'bg-green-50 text-green-700'
                          : stat.passRate >= 80
                            ? _unref(theme).isDark.value
                              ? 'bg-yellow-900 bg-opacity-30 text-yellow-400'
                              : 'bg-yellow-50 text-yellow-700'
                            : _unref(theme).isDark.value
                              ? 'bg-red-900 bg-opacity-30 text-red-400'
                              : 'bg-red-50 text-red-700',
                        'px-3 py-1.5 rounded-lg text-sm font-bold'
                      ])
                            }, _toDisplayString(stat.passRate) + "% ", 3)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_86, [
                          _createElementVNode("button", {
                            class: _normalizeClass([
                      _unref(theme).isDark.value
                        ? 'text-blue-400 hover:text-blue-300 hover:bg-blue-900 hover:bg-opacity-30'
                        : 'text-blue-600 hover:text-blue-700 hover:bg-blue-50',
                      'px-3 py-1.5 rounded-lg text-xs font-medium transition-all inline-flex items-center'
                    ]),
                            onClick: _withModifiers(($event: any) => (navigateToPRList(stat)), ["stop"])
                          }, _cache[34] || (_cache[34] = [
                            _createTextVNode(" View Details "),
                            _createElementVNode("svg", {
                              class: "w-3.5 h-3.5 ml-1",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M9 5l7 7-7 7"
                              })
                            ], -1)
                          ]), 10, _hoisted_87)
                        ])
                      ], 10, _hoisted_64))
                    }), 128))
                  ])
                ])
              ], 2)
            ]))
          : (leaderboardData.value && filteredStats.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-xl p-8 text-center shadow-sm'
        ])
              }, [
                _createElementVNode("div", _hoisted_88, [
                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "w-16 h-16 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center mb-3" }, [
                    _createElementVNode("svg", {
                      class: "h-8 w-8 text-gray-400 dark:text-gray-500",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("h3", {
                    class: _normalizeClass([
              _unref(theme).isDark.value ? 'text-white' : 'text-gray-900',
              'text-base font-semibold mb-1.5'
            ])
                  }, " No Data Available ", 2),
                  _createElementVNode("p", {
                    class: _normalizeClass([
              _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
              'text-xs max-w-md mb-4'
            ])
                  }, " No quality gate results found for the selected time range and filters. Try adjusting your filters or check back later. ", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass([
              _unref(theme).isDark.value
                ? 'bg-blue-600 hover:bg-blue-700 text-white'
                : 'bg-blue-500 hover:bg-blue-600 text-white',
              'px-5 py-2 rounded-lg text-xs font-medium transition-colors shadow-sm'
            ]),
                    onClick: fetchLeaderboard
                  }, " Refresh Data ", 2)
                ])
              ], 2))
            : _createCommentVNode("", true),
      (leaderboardData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _cache[37] || (_cache[37] = _createElementVNode("svg", {
                class: "w-3.5 h-3.5 text-gray-400",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                })
              ], -1)),
              _createElementVNode("span", {
                class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-500' : 'text-gray-500', 'text-xs'])
              }, [
                _cache[36] || (_cache[36] = _createTextVNode(" Generated at ")),
                _createElementVNode("span", _hoisted_91, _toDisplayString(formatGeneratedAt(leaderboardData.value.generatedAt)), 1)
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})